import { useEffect, useState } from "react";
import { useStore, useDispatch } from "../store";
import { setDrugMobileTocActiveTab } from "../store/actions";
import { tabTypes } from "../constants/tab-types";
import { drugMobileTocTabTypes } from "../constants/drug-mobile-toc-tab-types";

export default function useDrugMobileTocTabs(tabType, tabs) {
  const { drugMobileTocActiveTab } = useStore();
  const dispatch = useDispatch();
  const [hasDrugMobileTocTabs, setHasDrugMobileTocTabs] = useState(false);

  useEffect(() => {
    if (
      tabs &&
      tabs.findIndex(
        ({ testId }) => testId === drugMobileTocTabTypes.IN_DEPTH_ANSWERS
      ) > -1
    ) {
      setHasDrugMobileTocTabs(true);
    }
  }, [tabs]);

  useEffect(() => {
    if (hasDrugMobileTocTabs) {
      const drugMobileTocTab =
        tabType === tabTypes.DETAILS
          ? drugMobileTocTabTypes.IN_DEPTH_ANSWERS
          : drugMobileTocTabTypes.QUICK_ANSWERS;

      setDrugMobileTocActiveTab(dispatch, drugMobileTocTab);
    }
  }, [dispatch, tabType, hasDrugMobileTocTabs]);

  return {
    hasDrugMobileTocTabs,
    drugMobileTocActiveTab,
  };
}
